<template>
	<div id="echarts" style="width: 100%;height:320px;"></div>
</template>

<script>
	 // 引入 ECharts 主模块
	let echarts = require('echarts/lib/echarts');
	// 引入折线图/柱状图等组件
	require('echarts/lib/chart/line')
	// 引入提示框和title组件，图例
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/legend')
	export default {
		data() {
			return {
			}
		},
		mounted() {
			var myChart = echarts.init(document.getElementById('echarts'));
			var option = {
			    title: {
			        text: 'G2 Esports',
			    	top: '10%',
			        textStyle: {
			        	color: "#1CA3FC",
			        	fontSize: 12,
			        	fontWeight: 400
			        }
			    },
			    color: ["#F8B43F", "#126BFB"],
			    legend: {
                    icon: 'rect',
                    itemWidth: 24,
                    itemHeight: 12,
                    itemGap: 21,
                    data: [{
                    	name:"经济差",
                    },{
                    	name:"经验差",
                    }],
                    textStyle: {
                        fontSize: 12,
                        color: '#333'
                    }
                },
			    tooltip: {
			        trigger: 'axis',
			        padding: [5, 15],
			        formatter: function( datas ) { 
			        	var div = datas[0].axisValue+'<br /><span class="tip" style="background:'+datas[0].color+'"></span>'+datas[0].seriesName + ': ' + datas[0].data +'K<br /><span class="tip" style="background:'+datas[1].color+'"></span>'+datas[1].seriesName + ': ' + datas[1].data +'K'
						return div; // 由于可能有多个series，因 此  params[0].name和.data表示第一个series的该坐标点 xAxis值和yAxis值 
					} 
			    },
			    grid: {
			    	top: '20%',
			        left: '0%',
			        right: '2%',
			        bottom: '3%',
			        containLabel: true
			    },
			    xAxis: {
			        type: 'category',
			        boundaryGap: false,
			        data: ['0:18', '1:54', '3:32', '5:8', '6:44', '8:20', '9:56','0:18', '1:54', '3:32', '5:8', '6:44', '8:20', '9:56','0:18', '1:54', '3:32', '5:8', '6:44', '8:20', '9:56'],
	                //y轴线设置显示
	                axisLine : {
	                    show: true,
	                    onZero: false,
	                    lineStyle : {
	                    	color: "#E9E9E9",
	                        width : 2,
	                        type : 'solid',
	                    }
	                },
			        axisLabel: {
			        	color : '#999',
			        },
	                axisTick: {
	                	show: false
	                },
			    },
			    yAxis: {
			        type: 'value',
			        axisLabel: {
			        	color : '#666',
			        	formatter: '{value}K'
			        },
	                //y轴线设置显示
	                axisLine : {
	                    show : true,
	                    lineStyle : {
	                    	color: "#eee",
	                        width : 2,
	                        type : 'solid',
	                    }
	                },
	                axisTick: {
	                	lineStyle: {
	                		color: "#eee"
	                	}
	                },
	                //与x轴平行的线样式
	                splitLine : {
	                    show : true,
	                    lineStyle : {
	                        color : '#E9E9E9',
	                        width : 1,
	                        type : 'dashed',
	                    }
	                }
	                
			    },
			    series: [
			        {
			            name: '经济差',
			            type: 'line',
			            data: [0, -0.2, 0.2, -1, 1, 2, -5, 0, -0.2, 0.2, -1, 1, 2, -5, 0, -0.2, 0.2, -1, 1, 2, -5],
			            symbol: 'none'
			        },
			        {
			            name: '经验差',
			            type: 'line',
			            data: [0, -0.4, 0.4, 0, 1, 2, -5, 0, -0.2, 0.2, -1, 1, 2, -5, 0, -0.2, 0.2, -1, 1, 2, -5],
			            symbol: 'none'
			        },
			    ]
			};
			// 使用刚指定的配置项和数据显示图表。
        	myChart.setOption(option);
		}
	}
</script>

<style>
	.tip{
	 	display: inline-block;
	    margin-right: 5px;
	    border-radius: 10px;
	    width: 10px;
	    height: 10px;
	}
</style>